import { QueryClient, useQuery, UseQueryResult } from "@tanstack/react-query";
import { Client, Osdk } from "@osdk/client";
import { HenceGlobalTimezone } from "@unruly-osdk/sdk";

const keys = {
  all: ["timezones"] as const,
};
function TimezoneService(_queryClient: QueryClient, apiClient: Client) {
  const service = {
    useGetAll: (): UseQueryResult<Osdk.Instance<HenceGlobalTimezone>[]> => {
      return useQuery({
        queryKey: keys.all,
        queryFn: async () => {
          const result = await apiClient(HenceGlobalTimezone).fetchPage({
            $pageSize: 10000,
          });
          return result.data;
        },
      });
    },
  };
  return service;
}
export default TimezoneService;
